export default __webpack_public_path__ + "static/media/result-diagram.215ee846.png";